import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    heading: {
        fontSize: 16,
        fontWeight: 500,
        textAlign: 'center',
        fontFamily: 'arial',
        color: '#696b6e',
    },
    tableContainer: {
        padding: 8,
        margin: 8,
    },
    tableRow: {
        padding: '0px 16px',

        '&:nth-of-type(odd)': {
            backgroundColor: '#f8f8f8',
        },
    },
}));
